module.exports = __webpack_public_path__ + "static/media/about.47e582dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/about.jpg
// module id = 63
// module chunks = 0